import { render, staticRenderFns } from "./PlatformNumberField.vue?vue&type=template&id=2a140dd2"
import script from "./PlatformNumberField.vue?vue&type=script&lang=ts"
export * from "./PlatformNumberField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports